export default __webpack_public_path__ + "static/media/ilfracombe.524b32ce.png";